import apiHttpClient from "libs/api-http-client";
import { UserNotification } from "types/user-notification";

export interface UserInvitationQuery {
  fundId: number;
  userId: number;
}
export type NotificationUpdateFields = {
  contributionRequestConfirmation?: boolean;
  contributionRequestExecution?: boolean;
  contributionRequestCancellation?: boolean;
  reminderPendingContributionRequest?: boolean;
  grantVestmentRequestConfirmation?: boolean;
  grantVestmentRequestApproval?: boolean;
  grantVestmentRequestDeclination?: boolean;
  additionGrantVestmentRequestOfInterest?: boolean;
  updateFollowedGrantVestment?: boolean;
  reminderToBackFollowedGrantVestment?: boolean;
  followedGrantVestmentReachGoal?: boolean;
  backedGrantVestmentReachGoal?: boolean;
  backedGrantVestmentDoNotReachGoal?: boolean;
  investmentRequestConfirmation?: boolean;
  investmentRequestApproval?: boolean;
  investmentRequestDeclined?: boolean;
  grantRequestConfirmation?: boolean;
  grantRequestApproval?: boolean;
  grantRequestDeclined?: boolean;
};
export interface UpdateUserNotificationParams {
  userId: number;
  fundId?: number;
  allFunds?: boolean;
  updates: NotificationUpdateFields;
  disableAll?: boolean;
}
export const updateUserNotificationAPI = (
  userNotification: UpdateUserNotificationParams
): Promise<unknown> =>
  apiHttpClient.patch(
    `user-notification/${userNotification.userId}`,
    userNotification
  );

export const getUserNotificationAPI = (
  query: UserInvitationQuery
): Promise<UserNotification> =>
  apiHttpClient.get(`user-notification`, {
    params: {
      fundId: query.fundId,
      userId: query.userId,
    },
  });
